import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NotFound() {
  const location = useLocation();

  useDocumentTitle({
    title: "页面不存在-屁屁影院",
    description: "抱歉，您访问的页面不存在，返回屁屁影院首页继续浏览最新电影与电视剧。",
    keywords: "屁屁影院,页面不存在",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="font-heading text-7xl font-bold text-primary-500 md:text-9xl">404</span>
        <h1 className="mt-4 text-2xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-2 font-mono text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm text-foreground-500">
          您访问的页面不存在或已被移动，不如回首页看看有什么新片上映吧。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-950 hover:bg-background-100"
          >
            搜索影视
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}